import { Box, Heading, List, Paragraph } from '@zillow/constellation-10';

import WizardTipCardContainer from '../../../../../srcLegacy/shared/components/WizardTipCardContainer';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import EmailFormField from '../../../PostingPath/EmailFormField';
import ForRentByFieldSet from '../../../PostingPath/ForRentByFieldSet';
import NameFormField from '../../../PostingPath/NameFormField';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const WhoIsListingProperty = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
    >
      <div data-testid="WhoIsListingProperty">
        <Box css={wizardFlexContainerStyles}>
          <Box css={wizardFormSectionContainerStyles.raw()}>
            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              Who is listing this property?
            </Heading>

            <Paragraph css={wizardParagraphStyles}>
              Enter your information, unless you’re creating the listing for someone else and they should be the main
              contact person.
            </Paragraph>

            <ForRentByFieldSet />

            <NameFormField />

            <EmailFormField />
          </Box>

          <WizardTipCardContainer
            header="Tips for contact information"
            showDesktopViewBreakpoint={showDesktopViewBreakpoint}
          >
            <List.Root css={{ paddingLeft: '600' }}>
              <List.Item>We’ll deliver renter inquiries to the email you provide here.</List.Item>
              <List.Item>Other communications from Zillow will be sent to your account email.</List.Item>
            </List.Root>
          </WizardTipCardContainer>
        </Box>
      </div>
    </PageWizard>
  );
};

export default WhoIsListingProperty;
